import { translateTestimoniesArray } from '@app/models/api/TestimoniesModel';
import type { TestimonyModel, TestimonyRequest } from '@app/models/api/TestimoniesModel';
import { APIEndpoints } from '@app/enums/APIEndpoints';
import type { PaginationModel, PaginationQuery } from '@app/models/api/PaginationModel';
import { createPaginatedUrl, createPaginationModel } from '@app/models/api/PaginationModel';

export const getTestimonies = async (
	operationId: string,
	query?: PaginationQuery
): Promise<PaginationModel<TestimonyModel[]>> => {
	const url = createPaginatedUrl(APIEndpoints.OPERATIONS(operationId, 'testimonials'), query);
	const res = await fetch(url);
	const json = res.status === 204 ? {} : await res.json();
	try {
		const data = json?._embedded?.temoignages;
		const page = json?.page;
		return createPaginationModel(translateTestimoniesArray, data, page);
	} catch (e) {
		throw json;
	}
};

export const addTestimony = async (operationId: string, request: TestimonyRequest) => {
	const res = await fetch(APIEndpoints.OPERATIONS(operationId, 'testimonials'), {
		method: 'PUT',
		body: JSON.stringify(request)
	});
	const json = await res.json();
	if (res.ok) {
		return json;
	} else {
		throw json;
	}
};
